var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/UrgentSell/UrgentSellPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/UrgentSell/UrgentSellPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"UrgentSellPopup Service\">\n    <div class=\"Service-headerWrapper\">\n        <h1 class=\"Service-header\">Срочный выкуп квартиры</h1>\n        <a class=\"Service-close u-Route\" href=\"";
output += runtime.suppressValue((lineno = 5, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:index"])), env.opts.autoescape);
output += "\">\n            ";
output += runtime.suppressValue((lineno = 6, colno = 36, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["x",runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_5 = "";;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
return macro_t_4;})()})])), env.opts.autoescape);
output += "\n        </a>\n    </div>\n    <div class=\"Service-content Service-block Service-body\">\n        <div class=\"Service-desc Service-text\">\n            <p>Мы выкупаем одно/двух/трёхкомнатные квартиры в Москве. За них мы выплачиваем до 80% от рыночной цены.\n                Услуга подходит только тем, кому срочно нужны деньги. Если вы готовы подождать, мы можем предложить наши\n                услуги по стандартной продаже. Так мы продадим дороже, а вы получите больше денег.</p>\n            <p>При выкупе выдаём деньги за семь рабочих дней: до 8 млн рублей за однушку, до 10 млн рублей за двушку\n                и до 12 млн рублей за трёшку.</p>\n        </div>\n\n        <h2 class=\"Service-blockTitle\">Как всё устроено: от обращения за услугой до выплаты денег</h2>\n\n        <div class=\"UrgentSellPopup-ul\">\n            <ol>\n                <li>\n                    Дайте нам знать, если вы хотите, чтобы мы выкупили вашу квартиру. Напишите или позвоните. Если\n                    хотите прийти, то всё равно позвоните, чтобы мы смогли подготовиться к встрече, и она была полезной\n                    для вас.\n                </li>\n                <li>\n                    Мы осматриваем вашу квартиру в тот же или на следующий день.\n                </li>\n                <li>\n                    После осмотра мы оцениваем параметры квартиры, район и сопоставляем с альтернативными предложениями\n                    на рынке недвижимости.\n                </li>\n                <li>\n                    После осмотра и анализа рынка, мы готовим вам предложение о выкупе.\n                </li>\n                <li>\n                    Если вас устраивают все условия, мы подписываем договор, проводим сделку и перечисляем деньги.\n                </li>\n\n            </ol>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/UrgentSell/UrgentSellPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/UrgentSell/UrgentSellPopup.jinja
// module id = 99
// module chunks = 0